import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ApiTypes } from '../../..';
import type {
    DataLayerEntry,
    ModelTracking,
    TrackingElementType,
    TrackingEvent,
    TrackingPageElementStatusType,
} from '../../utilities/tracking';

export const actions = createActionGroup({
    source: 'tracking',
    events: {
        'Disable Event Tracking': emptyProps(),
        'Click Tracking': props<{
            elType: TrackingElementType;
            event: TrackingEvent;
            elLabel?: string;
            elTarget?: string;
            models?: ModelTracking[];
            vehicle?: ApiTypes.VehicleDetail;
            status?: TrackingPageElementStatusType;
        }>(),
        'Overlay Tracking': props<{ label: string }>(),
        'Filter Tracking': props<{ filterType: string }>(),
        'Set Models On Page Tracking': props<{
            models: ModelTracking[];
        }>(),
        'Form Test Drive Start Tracking': props<{ vehicle: ApiTypes.VehicleDetail }>(),
        'Form General Request Start Tracking': props<{ vehicle: ApiTypes.VehicleDetail }>(),
        'Form Reservation Start Tracking': props<{ vehicle: ApiTypes.VehicleDetail }>(),
        'Form Test Drive Submit Tracking': props<{
            form: { comment: string; date: string; day: string; time: string };
            contact: { name: string; email: string; phone?: string; generalMarketing: boolean };
            vehicle: ApiTypes.VehicleDetail;
        }>(),
        'Form General Request Submit Tracking': props<{
            form: { comment: string; subtopic: string };
            vehicle: ApiTypes.VehicleDetail;
            contact: { name: string; email: string; phone?: string; generalMarketing: boolean };
        }>(),
        'Form Reservation Submit Tracking': props<{
            vehicle: ApiTypes.VehicleDetail;
            contact: { name: string; email: string; phone?: string; generalMarketing: boolean };
        }>(),
        'Reset Models On Page Tracking': emptyProps(),
        'Event Tracking Push': props<{ dataLayer: DataLayerEntry }>(),
    },
});
